import CryptoJS from 'crypto-js';

const pwdHashAPI = {
  toSha512: (str) => {
    const sha512Hash = CryptoJS.SHA512(str).toString(CryptoJS.enc.Hex);

    return sha512Hash;
  },
};

export default pwdHashAPI;
